import { createContext } from 'react';
import { Maybe, Sale } from '@gql/schema';

export interface IServerStateContext {
  sale?: Maybe<Sale>;
}

export const ServerStateContext = createContext<IServerStateContext | undefined>(undefined);
